module.exports = __webpack_public_path__ + "img/10.2ee5f092.jpg";